<template>
  <div class="fill-and-flex overflow-y-scroll p-4 last:mb-0">
    <SettingsGroup title="Locale">
      <Setting
        title="Country"
        description="Used to construct the country code portion of the locale"
      >
        <Country />
      </Setting>

      <Setting
        title="Language"
        description="Used to construct the language code portion of the locale"
      >
        <Language />
      </Setting>
    </SettingsGroup>

    <SettingsGroup title="Development" v-if="showAdminArea">
      <Setting
        title="DNS Environment"
        description="Which environment's records to use"
      >
        <DnsEnvironment />
      </Setting>

      <Setting
        title="Modules Environment"
        description="Which environment's module files to use"
      >
        <ModulesEnvironment />
      </Setting>
    </SettingsGroup>
  </div>
</template>

<script>
import { STAGE } from "@/app.config";

import Country from "@/views/Settings/Country";
import DnsEnvironment from "@/views/Settings/DnsEnvironment";
import Language from "@/views/Settings/Language";
import ModulesEnvironment from "@/views/Settings/ModulesEnvironment";
import Setting from "@/views/Settings/Setting";
import SettingsGroup from "@/views/Settings/Group";

export default {
  name: "Settings",
  components: {
    Country,
    DnsEnvironment,
    Language,
    ModulesEnvironment,
    Setting,
    SettingsGroup,
  },
  computed: {
    showAdminArea() {
      return STAGE !== "prod";
    },
  },
};
</script>
